// utils/auth.js
import api from 'api/axios';

const AUTH_KEY = 'auth_ok';
const USER_KEY = 'auth_user';

export function isAuthed() {
  return localStorage.getItem(AUTH_KEY) === '1';
}
export function setAuthed(v, user) {
  if (v) {
    localStorage.setItem(AUTH_KEY, '1');
    if (user) {
      try {
        localStorage.setItem(USER_KEY, JSON.stringify(user));
      } catch {
        // ignore
      }
    }
  } else {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(USER_KEY);
  }
}

export function getUserInfo() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getUserRole() {
  const u = getUserInfo();
  return u?.role || '';
}

export async function logout() {
  try {
    await api.post('/api/logout', {});
  } catch (e) {}

  setAuthed(false);
}
